import { StatIcon } from '../common/statIcon';
import './statBanner.scss';
// import portIcon from '../assets/img/svg/port_icon.svg';
import routesIcon from '../assets/img/svg/routes_icon.svg';
import shipIcon from '../assets/img/svg/ship_icon.svg';
import employeesIcon from '../assets/img/svg/employees_icon.svg';

const StatBanner = ({ title }: { title: string }) => {
  return (
    <div className="banner-container">
      <div className='banner-content'>
        <h4 className='banner-header'>{title}</h4>
        <div className='banner-row'>
          <StatIcon iconSrc={shipIcon} number="11" unit='vessels'/>
          <StatIcon iconSrc={routesIcon} number=">500" unit='trips completed'/>
          <StatIcon iconSrc={employeesIcon} number=">200" unit='employees'/>
        </div>
      </div>
    </div>
  );
};

export default StatBanner;
